// CATT Quadrant Monogram — official mark.
// Single-color vector (uses currentColor) with a signal-red focal dot.
export default function CattLogo({ size = 28, accent = "#FF3333", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="CATT"
    >
      <rect x="3" y="3" width="94" height="94" stroke="currentColor" strokeWidth="4" />
      <line x1="50" y1="3" x2="50" y2="97" stroke="currentColor" strokeWidth="4" />
      <line x1="3" y1="50" x2="97" y2="50" stroke="currentColor" strokeWidth="4" />
      <text
        x="26.5"
        y="40"
        textAnchor="middle"
        fontFamily="'Cabinet Grotesk', sans-serif"
        fontWeight="800"
        fontSize="28"
        fill="currentColor"
      >
        C
      </text>
      <text
        x="73.5"
        y="40"
        textAnchor="middle"
        fontFamily="'Cabinet Grotesk', sans-serif"
        fontWeight="800"
        fontSize="28"
        fill="currentColor"
      >
        A
      </text>
      <text
        x="26.5"
        y="83"
        textAnchor="middle"
        fontFamily="'Cabinet Grotesk', sans-serif"
        fontWeight="800"
        fontSize="28"
        fill="currentColor"
      >
        T
      </text>
      <text
        x="73.5"
        y="83"
        textAnchor="middle"
        fontFamily="'Cabinet Grotesk', sans-serif"
        fontWeight="800"
        fontSize="28"
        fill="currentColor"
      >
        T
      </text>
      <circle cx="50" cy="50" r="5" fill={accent} />
    </svg>
  );
}
